import reducer from "./reducer";
export { default as AccumulatorSettings } from "./components/index";
export { default as accumulatorSettingsReducerName } from "./constants";
export default reducer;
